import dayjs from 'dayjs'
dayjs.extend(require('dayjs/plugin/customParseFormat'))

const formatDate = ({ date, inputFormat = 'YYYY-MM-DD', outputFormat = 'YYYY-MM-DD'}) => {
  if (!date) return null

  switch (typeof date) {
    case 'object': 
      return dayjs(date).format(outputFormat)
    case 'string':
      if (inputFormat === outputFormat)
        return date
      else
        return dayjs(date, inputFormat).format(outputFormat)
    default:
      return null
  }
}

const parseDate = ({ date, inputFormat = 'YYYY-MM-DD', outputPlugin = true }) => {
  const _date = date || new Date()
  switch (typeof _date) {
    case 'object': 
      return outputPlugin ? dayjs(_date) : _date
    case 'string':
      return outputPlugin ? dayjs(_date, inputFormat) : dayjs(_date, inputFormat).toDate()
    default:
      return null
  }
}

const isDateValid = ({ date, inputFormat = 'YYYY-MM-DD' }) => {
  const _date = dayjs(date, inputFormat)
  return _date.format(inputFormat) === date
}

export { formatDate, parseDate, isDateValid }